<template>
  <div class="header_wrapper">
    <div class="header">
      <a href="" @click.prevent="linkToIndex" class="logo">
        <img src="@/assets/images/logo.svg" alt="Logo" class="logo" />
      </a>
      <div class="right_wrapper">
        <router-link to="/ourwork" :class="{ active: route.name.indexOf('Ourwork') > -1 }" class="pc_link">
          Ourwork
        </router-link>
        <router-link to="/news" :class="{ active: route.name.indexOf('News') > -1 }" class="pc_link">
          News & Stories
        </router-link>
        <router-link to="/aboutUs" :class="{ active: route.name.indexOf('AboutUs') > -1 }" class="pc_link">
          About Us
        </router-link>
        <router-link to="/partnerships" :class="{ active: route.name.indexOf('Partnerships') > -1 }" class="pc_link">
          Partnerships
        </router-link>
        <router-link to="/index" class="moblie_link">
          <img src="@/assets/images/home.svg" alt="home" class="home" />
        </router-link>
        <a-dropdown trigger="click" placement="bottomRight" overlayClassName="menu_dropdown">
          <router-link to="" class="moblie_link">
            <img src="@/assets/images/menu.svg" alt="menu" class="menu" />
          </router-link>
          <template #overlay>
            <a-menu>
              <router-link to="/ourwork" :class="{ active: route.name.indexOf('Ourwork') > -1 }" class="menu_link">
                Ourwork
              </router-link>
              <router-link to="/news" :class="{ active: route.name.indexOf('News') > -1 }" class="menu_link">
                News & Stories
              </router-link>
              <router-link to="/aboutUs" :class="{ active: route.name.indexOf('AboutUs') > -1 }" class="menu_link">
                About Us
              </router-link>
              <router-link
                to="/partnerships"
                :class="{ active: route.name.indexOf('Partnerships') > -1 }"
                class="menu_link"
              >
                Partnerships
              </router-link>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie';
import { defineComponent, onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const router = useRouter();
const store = useStore();

const linkToIndex = () => {
  if (isHome.value) {
    window.location.reload();
  } else {
    router.push('/index');
  }
};

const isHome = computed(() => route.path === '/index');

onMounted(() => {});
</script>

<style lang="less" scoped>
.header_wrapper {
  background: #fff;
  z-index: 1;
  position: fixed;
  background: #fff;
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  .header {
    padding: 10px 0;
    overflow: hidden;
    max-width: 1280px;
    margin: 0 auto;
    .logo {
      float: left;
      margin-top: 5px;
      width: 240px;
      height: auto;
      cursor: pointer;
      padding-bottom: 8px;
    }
    .right_wrapper {
      float: right;
      .pc_link {
        color: #333333;
        font-size: 14px;
        text-decoration: none;
        cursor: pointer;
        padding-bottom: 10px;
        display: inline-block;
        width: 120px;
        text-align: center;
        margin: 16px 5px 0;
        .link_icon {
          margin-right: 5px;
          &.icon_smile {
            width: 24px;
            height: 24px;
            vertical-align: middle;
          }
          &.icon_user {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
        }
        &.active,
        &:hover {
          font-weight: bold;
          color: #000000;
          border-bottom: 4px solid #f78335;
        }
      }
      .moblie_link {
        margin: 0 16px;
        width: 20px;
        height: auto;
        line-height: 50px;
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    .header {
      .logo {
        margin-left: 8px;
      }
      .right_wrapper {
        .pc_link {
          display: none;
        }
        .moblie_link {
          display: inline;
        }
      }
    }
  }
}
</style>

<style lang="less">
.menu_dropdown {
  width: 200px;
  .menu_link {
    color: #000;
    font-size: 16px;
    padding: 16px;
    display: block;
  }
}
</style>
